export async function fetchDataset({
  url,
  method = "GET",
  token = null,
  params = null,
  body = null,
  signal = null,
}) {
  try {
    // Base API (se usi Vite: VITE_API_BASE, se CRA: REACT_APP_API_BASE)
    const API_BASE =
      (import.meta?.env?.VITE_API_BASE ||
        process.env.REACT_APP_API_BASE ||
        "https://api.lapegna.eu").trim();

    // ✅ FORZA URL ASSOLUTO (se url è "/registro_segnalazioni" lo trasforma in https://api.lapegna.eu/registro_segnalazioni)
    const u = new URL(url, API_BASE);

    // querystring
    if (params && typeof params === "object") {
      Object.entries(params).forEach(([k, v]) => {
        if (v !== null && v !== undefined && v !== "") u.searchParams.set(k, String(v));
      });
    }

    const finalUrl = u.toString();
    console.log("fetchDataset FINAL URL:", finalUrl);

    const res = await fetch(finalUrl, {
      method,
      signal,
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      ...(body ? { body: JSON.stringify(body) } : {}),
    });

    if (!res.ok) {
      const txt = await res.text();
      throw new Error(txt || `Errore HTTP ${res.status}`);
    }

    const json = await res.json();

    const rows =
      Array.isArray(json)
        ? json
        : json.items ||
          json.rows ||
          json.data ||
          json.segnalazioni ||
          json.results ||
          [];

    const columns =
      rows.length > 0
        ? Object.keys(rows[0]).map((key) => ({
            key,
            label: key,
            sortable: true,
          }))
        : [];

    return { rows, columns, raw: json };
  } catch (err) {
    throw err;
  }
}